import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect to chat if it's NOT the login page
    // and not already at chat
    if (
      location.pathname !== "/" &&
      location.pathname !== "/chat"
    ) {
      navigate("/chat?new_conversation", { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <div className="flex flex-col items-center justify-center w-full h-full">
      <p>Route Not Found</p>
    </div>
  );
};

export default NotFound;
